import { Button } from "antd";
import { Link } from "react-router-dom";
import { ONBOARD } from "../../constants/constants";
import { useAuth } from "../context/AuthContext";
import { useWalletBalance } from "../../hooks/wallets/useWalletBalance";
import { DIM_COLOR, primary5 } from "../../constants/colors";
import {
  formatWalletNumber,
  getDisplayName,
  stringify,
} from "../../utils/helpers";
import { CardIcon } from "../../assets/svg/Svgs";
import { IconButton } from "@mui/material";
import { Divider } from "./Elements";

export const InfoCard = ({
  data: { title, actionText, desc, to },
}: {
  data: {
    title: string;
    actionText?: string;
    desc?: string;
    to?: string | any;
  };
}) => {
  return (
    <div className="p20 whiteBg r10 flex">
      <div className="flexNullCenter gap15 x100">
        <div className="flexGrow">
          <div className="semiBold textDark">{title}</div>
          <div className="grey font11">{desc}</div>
        </div>

        <Link to={to}>
          <Button className="font12 r20 noShadow" type="primary">
            {actionText}
          </Button>
        </Link>
      </div>
    </div>
  );
};
// Onboarding
// Complete
// Complete your onboarding process

export const OnboardCard = () => {
  return (
    <InfoCard
      data={{
        title: "Onboarding",
        actionText: "Complete",
        desc: "Complete your onboarding process",
        to: ONBOARD,
      }}
    />
  );
};

export const FundSourceCard = () => {
  const { user } = useAuth();
  const { wallet } = user || {};
  const { wallet_number, balance } = wallet || {};
  const { toggleBalance, displayAmount, icon: Icon } = useWalletBalance();

  return (
    <div className="textDark">
      {/* DATA */}
      <div
        className="lightBg p10 r10"
        style={{
          border: `1px solid ${primary5}`,
        }}
      >
        <div className="font12 mb10 grey semiBold">Fund Source</div>

        <div className="gap10 flexColumn whiteBg p15 r10 hidden">
          {/* ACCOUNT */}
          <div className="gap15 flexNullCenter">
            <div className="flexGrow">
              <div className="semiBold font13 mb5">
                {formatWalletNumber(wallet_number)}
              </div>
              <div className="font11 grey">{getDisplayName(user)}</div>
            </div>
            <CardIcon fontSize={25} className="grey" />
          </div>

          <Divider />

          {/* BALANCE */}
          <div className="gap15 flexNullCenter whiteBg r10">
            <div className="flexGrow textDark">
              <div className="font11 grey mb5">Available Balance</div>
              <div className="font13 semiBold" data-aos="fade-up">
                UGX {displayAmount(balance)}
              </div>
            </div>
            <div className="textDark">
              <IconButton
                size="small"
                onClick={toggleBalance}
                style={{ color: DIM_COLOR }}
              >
                <Icon fontSize="small" />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CalculatorCard = ({
  fields,
  title,
}: {
  fields: any;
  title?: any;
}) => {
  return (
    <div
      className="r10 lightBg p15 flexColumn gap10 textDark font13 hidden capitalize"
      style={{ border: `1px solid ${primary5}` }}
    >
      {title && <div className="grey font12 semiBold mb5">{title}</div>}
      {Object?.entries(fields)?.map(([key, value]: any, i) => {
        const isLastRow = Object?.entries(fields)?.length - 1 === i;
        const lastFieldKey = isLastRow && fields?.[key]; // animate layout changes
        return (
          <div className={`flexSpaceCenter ${isLastRow && "bold"}`} key={i}>
            {/* LEFT */}
            <div>{stringify(key)}</div>

            {/* RIGHT */}
            <div data-aos={isLastRow && "fade-up"} key={lastFieldKey}>
              {stringify(value?.toString())}
            </div>
          </div>
        );
      })}
    </div>
  );
};
